import { defineStore } from 'pinia'

export const useAiAgentStore = defineStore('aiAgent', {
  state: () => ({
    aiAgentOpened: false,
    aiAgentPage: 'home',
    aiAgentWindowWidth: 385,
    aiAgentThreadId: null,
    newMessageText: '',
  }),
  actions: {
    setAiAgentOpened (value: boolean) {
      this.aiAgentOpened = value
    },
    setNewMessageText (value: string) {
      this.newMessageText = value
    }
  },
})
